<template>
  <div class="page_ BJQ_">
    <div
      v-if="
        quotationData.quotationInfo.templateCode &&
        quotationData.quotationInfo.templateCode == '001'
      "
    >
      <div class="header">
        <!-- <img
        v-if="quotationData.quotationInfo.productImg"
        :src="quotationData.quotationInfo.productImg"
        alt=""
      /> -->
        <p class="text_">{{ quotationData.quotationInfo.name }}</p>
      </div>
      <div class="main_con">
        <!-- 首页表单 -->
        <a-form
          layout="horizontal"
          class="horizontal_item_"
          :form="form"
          @submit="handleSubmit"
        >
          <a-row>
            <div class="block_">
              <a-col>
                <a-form-item v-if="!show" label="客户名称" class="form_item_">
                  <a-input
                    @blur="(e) => handleInputBlur(e, 'HOLDER_NAME')"
                    placeholder="请输入客户名称"
                    v-decorator="[
                      'userName',
                      {
                        rules: [{ required: true, message: '请输入客户名称' }],
                      },
                    ]"
                  ></a-input>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>客户名称</div>
                  <div>{{ formInfo.userName }}</div>
                </div>
              </a-col>
              <a-col v-for="(item, index) in commonSelect" :key="index + 'com'">
                <div v-if="item.premiumRules && item.premiumRules.length > 0">
                  <a-form-item
                    v-if="!show"
                    :label="item.itemName"
                    class="form_item_"
                  >
                    <a-select
                      @change="
                        (val) => commonSelectChange(val, item, 'itemType', 'I')
                      "
                      placeholder="请选择"
                      v-decorator="[
                        item.itemType,
                        { rules: [{ required: true, message: '请选择' }] },
                      ]"
                    >
                      <a-select-option
                        v-for="(ele, idx) in item.premiumRules"
                        :key="'pre_' + idx + index"
                        :value="ele.optinonValue"
                      >
                        {{ ele.optinonName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="s_flex_" v-else>
                    <div>{{ item.itemName }}</div>
                    <div>
                      {{
                        formInfo[item.itemType]
                          | filterSelect(item.premiumRules)
                      }}
                    </div>
                  </div>
                </div>
              </a-col>

              <!-- 施工地区 -->
              <a-col>
                <a-form-item v-if="!show" label="施工地区" class="form_item_">
                  <a-select
                    @change="areaChange"
                    placeholder="请选择"
                    v-decorator="[
                      'address',
                      { rules: [{ required: true, message: '请选择' }] },
                    ]"
                  >
                    <a-select-option
                      v-for="ele in province"
                      :key="ele.provinceCode"
                      :value="ele.provinceCode"
                    >
                      {{ ele.provinceName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>施工地区</div>
                  <div>{{ formInfo.address | filterProvince }}</div>
                </div>
              </a-col>

              <!-- 工程造价 -->
              <a-col>
                <a-form-item v-if="!show" label="工程造价" class="form_item_">
                  <a-input-number
                    @blur="(e) => handleInputBlur(e, 'PROJECT_AMOUNT')"
                    style="width: 100%"
                    placeholder="请输入工程造价"
                    v-decorator="[
                      'projectCost',
                      {
                        rules: [{ required: true, message: '请输入工程造价' }],
                      },
                    ]"
                  ></a-input-number>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>工程造价</div>
                  <div>{{ formInfo.projectCost + "元" }}</div>
                </div>
              </a-col>

              <!-- 施工起期 -->
              <a-col>
                <a-form-item v-if="!show" label="施工起期">
                  <a-date-picker
                    :disabled-date="disabledDate"
                    @change="
                      (date, dateString) =>
                        dateChange(date, dateString, 'EFFECTIVE_DATE')
                    "
                    style="width: 100%"
                    placeholder="请选择"
                    v-decorator="[
                      'insureStartDate',
                      { rules: [{ required: true, message: '请选择' }] },
                    ]"
                  >
                  </a-date-picker>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>施工起期</div>
                  <div>
                    {{ moment(formInfo.insureStartDate).format("YYYY-MM-DD") }}
                  </div>
                </div>
              </a-col>
              <a-col>
                <a-form-item v-if="!show" label="施工止期">
                  <a-date-picker
                    :disabled-date="disabledDateEnd"
                    @change="
                      (date, dateString) =>
                        dateChange(date, dateString, 'EXPIRE_DATE')
                    "
                    style="width: 100%"
                    placeholder="请选择"
                    v-decorator="[
                      'insureEndDate',
                      { rules: [{ required: true, message: '请选择' }] },
                    ]"
                  >
                  </a-date-picker>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>施工止期</div>
                  <div>
                    {{ moment(formInfo.insureEndDate).format("YYYY-MM-DD") }}
                  </div>
                </div>
              </a-col>

              <!-- 佣金比例 -->
              <a-col v-if="COMMISSION_RATE">
                <a-form-item v-if="!show" label="佣金比例" class="form_item_">
                  <a-input-number
                    :min="0"
                    @blur="(e) => handleInputBlur(e, 'COMMISSION_RATE')"
                    style="width: 100%"
                    placeholder="请输入佣金比例（%）"
                    v-decorator="[
                      'commission',
                      {
                        rules: [{ required: true, message: '请输入佣金比例' }],
                      },
                    ]"
                  ></a-input-number>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>佣金比例</div>
                  <div>{{ formInfo.commission + "%" }}</div>
                </div>
              </a-col>

              <!-- 投保份数 -->
              <a-col v-if="INSURED_COUNT">
                <a-form-item v-if="!show" label="投保份数" class="form_item_">
                  <a-input-number
                    :min="0"
                    :max="MaxInsuredCount"
                    :step="1"
                    @blur="(e) => handleInputBlur(e, 'INSURED_COUNT')"
                    style="width: 100%"
                    placeholder="请输入投保份数"
                    v-decorator="[
                      'insureCount',
                      {
                        rules: [
                          { required: true, message: '请输入投保份数' },
                          { pattern: /^[1-9]\d*$/, message: '只允许正整数' },
                        ],
                      },
                    ]"
                  ></a-input-number>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>投保份数</div>
                  <div>{{ formInfo.insureCount }}</div>
                </div>
              </a-col>
            </div>
            <!-- <div class="tips_">保险起期不得早于工程实际开工日期；</div>
            <div class="tips_ tips_1">保险止期不得晚于工程实际竣工日期。</div> -->
          </a-row>
          <a-row>
            <div class="block_ border_">
              <div class="title_">
                <span>必选主险</span>
                <span>保险金额</span>
              </div>
              <a-col class="wid_label_">
                <a-form-item
                  v-if="!show"
                  :label="mainRiskInfo.coverageName"
                  class="form_item_ long"
                >
                  <a-select
                    @change="
                      (val) =>
                        commonSelectChange(
                          val,
                          mainRiskInfo,
                          'coverageCode',
                          'C'
                        )
                    "
                    placeholder="请选择"
                    v-decorator="[
                      'mainRiskValue',
                      { rules: [{ required: true, message: '请选择' }] },
                    ]"
                  >
                    <a-select-option
                      v-for="(item, index) in mainRiskInfo.premiumList"
                      :key="index + 'p_'"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>{{ mainRiskInfo.coverageName }}</div>
                  <div>{{ formInfo.mainRiskValue }}</div>
                </div>
              </a-col>
              <div class="title_">
                <span>可选附加险</span>
                <span>保险金额</span>
              </div>
              <a-col
                v-for="(risk, riskIdx) in otherRiskList"
                :key="'risk' + riskIdx"
                class="wid_label_"
              >
                <a-form-item
                  v-if="!show"
                  :label="risk.coverageName"
                  class="form_item_ long"
                >
                  <a-select
                    @change="
                      (val) =>
                        commonSelectChange(val, risk, 'coverageCode', 'C')
                    "
                    placeholder="请选择"
                    v-decorator="[
                      risk.coverageCode,
                      { rules: [{ required: true, message: '请选择' }] },
                    ]"
                  >
                    <a-select-option
                      v-for="(item, index) in risk.list"
                      :key="index + 'P_1'"
                      :value="item.selectValue"
                    >
                      {{ item.selectText }}
                      {{
                        item.selectText != "不附加" &&
                        risk.coverageName.indexOf("津贴") > -1
                          ? "元/天"
                          : ""
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <div class="s_flex_" v-else>
                  <div>{{ risk.coverageName }}</div>
                  <div>
                    {{ formInfo[risk.coverageCode] }}
                    {{ risk.coverageName.indexOf("津贴") > -1 ? "元/天" : "" }}
                  </div>
                </div>
              </a-col>

              <!-- 免赔额部分 -->
              <div v-if="deductibleList.length>0">
                <div class="title_">
                  <span>免赔额</span>
                  <!-- <span>保险金额</span> -->
                </div>
                <a-col
                  v-for="(obj, objIdx) in deductibleList"
                  :key="'obj' + objIdx"
                  class="wid_label_"
                >
                  <a-form-item
                    v-if="!show"
                    :label="obj.coverageName"
                    class="form_item_ form_item_1 long"
                  >
                    <a-select
                      @change="(val) => deductChange(val, obj)"
                      placeholder="请选择"
                      v-decorator="[
                        obj.coverageCode + '_deduct',
                        { rules: [{ required: true, message: '请选择' }] },
                      ]"
                    >
                      <a-select-option
                        v-for="(item, index) in obj.premiumRules"
                        :key="index + 'P_1'"
                        :value="item.optinonValue"
                      >
                        {{ item.optinonValue }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <div class="s_flex_" v-else>
                    <div>{{ obj.coverageName }}</div>
                    <div>
                      {{ formInfo[obj.coverageCode + "_deduct"] }}
                    </div>
                  </div>
                </a-col>
              </div>
              <!-- 免赔额部分 -->
              
              <div class="title_">
                <span>总保费</span>
                <span>{{ totalPremium }}元</span>
              </div>
            </div>
          </a-row>
        </a-form>
      </div>
      <div class="tab_">
        <span
          v-for="(item, index) in quotationData.labelContents"
          :key="index + 'tab'"
          @click="changeTab(item, index)"
          :class="{ on: index == nowTabIndex }"
          >{{ item.contentTitle }}</span
        >
      </div>
      <div v-if="!show" class="read">
        <a-checkbox @change="onChange" :checked="isCheck"
          ><span class="check"
            >我已阅读并知晓产品须知及条款内容</span
          ></a-checkbox
        >
      </div>

      <div v-if="!show" class="bottom_btn">
        <span @click="handleDisplay">转发报价</span>
      </div>
    </div>
    <div
      v-if="
        quotationData.quotationInfo.templateCode &&
        quotationData.quotationInfo.templateCode != '001'
      "
    >
      <tuanYi :show="show" :id="this.quoteId.toString()" />
    </div>
  </div>
</template>

<script>
import api from "@/utils/sdApi";
import moment from "moment";
import tuanYi from "./tuanYi";
import common from "../common.js";
let app = {};
export default {
  components: {
    tuanYi,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      isCheck: true,
      quotationData: {
        labelContents: [],
        quotationInfo: {
          productImg: "",
        },
      }, //报价数据
      pakageTypeOptions: [
        {
          text: "劳务分包工程（非劳务清包）",
          value: "0",
        },
        {
          text: "非劳务分包合同",
          value: "1",
        },
      ],
      province: [], //省列表
      mainRiskInfo: {}, //主险保费列表
      otherRiskList: [],
      initOtherRiskList: [], //始终不变
      projectCostOptions: [
        {
          text: "10万（不含）-100万",
          value: "0",
        },
        {
          text: "100万（不含）-500万（含）",
          value: "1",
        },
      ],
      projectCostOptions2: [],
      projectCostOptions3: [],
      nowTabIndex: 0,
      quoteId: 9, //报价id
      itemTypeList: [
        "PROJECT_TYPE",
        "PROJECT_SUBCONTRACT",
        "HURT_STANDARD",
        "CONSTRUCTION_QUALIFICATION",
      ], //通用类型itemType
      commonSelect: [],
      calculInfo: {
        //计算信息
        items: [],
      },
      deductibleList: [],//免赔额列表
      COMMISSION_RATE:false,
      INSURED_COUNT: false,
      MaxInsuredCount: 0, //最大投保分数
      pageConfig: {
        dayMaxUnit: "d",
        dayMax: 1,
      },
      totalPremium: 0,
      formInfo: {},
      show: false,
    };
  },
  beforeCreate() {
    app = this;
  },
  filters: {
    filterSelect(val, option) {
      let v = "";
      option.map((item) => {
        if (val == item.optinonValue) {
          v = item.optinonName;
        }
      });
      return v;
    },
    filterProvince(val) {
      let v = "";
      app.province.map((item) => {
        if (val == item.provinceCode) {
          v = item.provinceName;
        }
      });
      return v;
    },
  },
  inject: ["reload", "close"],
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.quoteId = id;
    }
    const tab = sessionStorage.getItem("tab_");
    if (tab) {
      this.nowTabIndex = tab;
    }

    const { show } = this.$route.params;
    //查询报价信息
    if (show) {
      this.show = JSON.parse(show);
      this.queryProvinces().then(() => {
        this.quotationLinkData("Q", "", (res) => {
          this.formInfo = JSON.parse(res.data.msg);
          this.totalPremium = this.formInfo.totalPremium;
          // this.setDisplayValue();
        });
      });
    }

    this.queryQuotationInfo().then(() => {
      if (this.quotationData.quotationInfo.templateCode == "001") {
        if (!show) {
          this.getPageConfig();
          this.queryProvinces();
        }
      }
    });
  },
  methods: {
    moment,
    //建工模板start
    onChange(e) {
      console.log(e.target);
      this.isCheck = e.target.checked;
    },
    disabledDate(current) {
      return current && current < moment().endOf("day");
    },
    disabledDateEnd(current) {
      let start = this.form.getFieldValue("insureStartDate");
      let config = this.pageConfig;
      let MinDate = moment(start).subtract(1, "days").endOf("day");
      let MaxDate = moment(start).endOf("day");
      let unit = "days";
      if (config.dayMaxUnit == "m") {
        unit = "months";
      } else if (config.dayMaxUnit == "y") {
        unit = "years";
      }
      MaxDate = moment(start)
        .add(config.dayMax, unit)
        .subtract(1, "days")
        .endOf("day");
      if (config.dayMaxIsContain == "0") {
        MaxDate = moment(start)
          .add(config.dayMax, unit)
          .subtract(2, "days")
          .endOf("day");
      }
      return current && (current < MinDate || current > MaxDate);
    },
    getPageConfig() {
      let data = {
        quoteId: this.quoteId,
        type: "POLICY_DAYS",
      };
      api.getPageConfig(data).then((res) => {
        this.pageConfig = res.data.msg["POLICY_DAYS"];
      });
    },
    handleSubmit() {},
    setDisplayValue() {
      //设置详情页展示
      // let form = JSON.parse(sessionStorage.getItem("f_"));
      let form = this.formInfo;
      console.log(form, "-------->form");
      let items = JSON.parse(sessionStorage.getItem("items"));
      if (form && items) {
        console.log(form, "表单数据");
        let formSet = { ...form };
        delete formSet.totalPremium;
        this.form.setFieldsValue({
          ...formSet,
          insureStartDate: moment(form.insureStartDate),
          insureEndDate: moment(form.insureEndDate),
        });
        this.totalPremium = form.totalPremium;
        this.calculInfo.items = items;
        console.log(this.calculInfo, "取计算数据");
      }
    },
    deelAddiRisk(val) { //附加险处理
      let value = parseInt(val) / 10;
      let list = [...this.initOtherRiskList];
      console.log(value, list, "----->list");
      let array = [];
      list.map((item) => {
        if (item.calculateMethod == 1) {
          let arr = [];
          item.list.map((ele) => {
            if (parseInt(ele.selectValue) <= value) {
              arr.push(ele);
            }
          });
          array.push({
            ...item,
            list: arr,
          });
        } else {
          array.push(item);
        }
      });
      this.otherRiskList = [...array];
    },
    //免赔额选择
    deductChange(val, obj) {
      console.log(val, obj);
      let list = this.calculInfo.items;
      let index = list.findIndex((item) => {
        return item.itemType == obj.coverageCode;
      });
      console.log(index,"exit?")
      if (index > -1) {
        list[index].deductibleAmount = val;
        console.log(list[index],"--list[index]")
      } else {
        list.push({
          itemCategory: "C",
          itemType: obj.coverageCode,
          deductibleAmount: val,
        });
      }

      this.calculInfo.items = [...list]
      this.calculatePremium();
    },
    commonSelectChange(val, record, key, type) {
      console.log(val, record);
      if (record.riskType == 1) {
        this.deelAddiRisk(val); //重新计算附加险可选值
      }
      //以下拼接计算接口参数
      let arr = this.calculInfo.items;
      let exitIndex = arr.findIndex((item) => {
        return item.itemType === record[key];
      });
      if (exitIndex > -1) {
        arr[exitIndex].itemValue = val;
      } else {
        arr.push({
          itemCategory: type,
          itemType: record[key],
          itemValue: val,
        });
      }
      this.calculInfo.items = [...arr];
      this.calculatePremium();
      console.log(this.calculInfo, "this.calculInfo");
    },
    areaChange(val) {
      let arr = this.calculInfo.items;
      this.setItems(val, "PROVINCE", "I");
      console.log(this.calculInfo, "this.calculInfo");
    },
    handleInputBlur(e, key) {
      let val = e.target.value;
      this.setItems(val, key, "I");
      console.log(this.calculInfo, "this.calculInfo");
    },
    dateChange(date, dateString, key) {
      this.setItems(dateString, key, "I");
    },
    setItems(val, key, type) {
      let arr = this.calculInfo.items;
      let exitIndex = arr.findIndex((item) => {
        return item.itemType == key;
      });
      if (exitIndex > -1) {
        arr[exitIndex].itemValue = val;
      } else {
        arr.push({
          itemCategory: type,
          itemType: key,
          itemValue: val,
        });
      }
      this.calculInfo.items = [...arr];
      this.calculatePremium();
      console.log(this.calculInfo, "this.calculInfo");
    },
    queryProvinces() {
      return api.queryProvinces().then((res) => {
        this.province = res.data;
      });
    },
    queryQuotationInfo() { //信息查询
      let data = {
        quoteId: this.quoteId,
        type: "Q",
      };
      return api.queryQuotationInfo(data).then((res) => {
        this.quotationData = res.data.msg;
        if (this.quotationData.quotationInfo.templateCode == "001") {
          this.formatCommonSelect();  //通用类型数据下拉框，统一处理
          this.formatMainRisk();  //处理主险数据
          this.formatOtherRisk();  //处理附加险数据
          this.formatDeductible(); //免赔额度处理
        }
      });
    },
    formatDeductible() {
      //免赔额度处理
      if(this.quotationData.deductibleList){
        this.deductibleList = this.quotationData.deductibleList;
      }
    },
    formatOtherRisk() {
      let data = this.quotationData.quotationCoverages;
      let otherRisk = data.filter((item) => {
        return item.riskType != 1;
      });
      console.log(otherRisk, "其他附加险");
      let other = this.divideGroup(otherRisk, "coverageCode");
      this.otherRiskList = other;
      this.initOtherRiskList = other;
      console.log(this.otherRiskList, "-->this.otherRiskList");
    },
    divideGroup(array, key) {
      //分组
      //收集key
      let result = [],
        keyArr = [],
        reciveArr = [];
      array.map((item) => {
        if (keyArr.indexOf(item[key]) == -1) {
          keyArr.push(item[key]);
        }
      });
      console.log(keyArr, "key-->all");

      //筛选不同代码产品
      keyArr.map((ele) => {
        let arr = [];
        array.map((item) => {
          if (ele == item[key]) {
            arr.push(item);
          }
        });
        reciveArr.push(arr);
      });
      console.log(reciveArr, "初步分组结果集");

      reciveArr.map((item) => {
        result.push(this.removeRepeat(item, "insuredAmount"));
      });

      return result;
    },
    removeRepeat(array, key) {
      let result = {},
        keyArr = [],
        list = [];
      list.push({
        selectValue: 0,
        selectText: "不附加",
      });
      array.map((item) => {
        if (keyArr.indexOf(item[key]) == -1) {
          keyArr.push(item[key]);
          list.push({
            ...item,
            selectValue: item[key],
            selectText: item[key],
          });
        }
      });

      result = {
        coverageCode: array[0].coverageCode,
        coverageName: array[0].coverageName,
        calculateMethod: array[0].calculateMethod,
        list: list,
      };
      console.log(keyArr, key, result);
      return result;
    },
    formatMainRisk() {
      let data = this.quotationData.quotationCoverages;
      let mainRiskInfo = {
        premiumList: [],
      }; //主险目前按照一个计算

      let mainRisk = data.filter((item) => {
        return item.riskType == 1;
      });
      mainRiskInfo.coverageName = mainRisk[0].coverageName; //主险目前按照一个计算
      mainRiskInfo.coverageCode = mainRisk[0].coverageCode;
      mainRiskInfo.riskType = 1;

      mainRisk.map((item) => {
        if (mainRiskInfo.premiumList.indexOf(item.insuredAmount) == -1) {
          mainRiskInfo.premiumList.push(item.insuredAmount);
        }
      });
      console.log(mainRisk, "主险信息", mainRiskInfo);
      this.mainRiskInfo = mainRiskInfo;
    },
    formatCommonSelect() {
      //处理其他险别通用类型数据
      let arr = [];
      this.quotationData.quotationItems.map((item) => {
        if (this.itemTypeList.indexOf(item.itemType) > -1) {
          arr.push(item);
        }
      });
      this.commonSelect = arr;
      console.log(arr, "-->commonSelect");

      this.showAnyFormProp();
    },
    showAnyFormProp() {
      //是否展示展示某些表单组件 COMMISSION_RATE,INSURED_COUNT
      let key = ["COMMISSION_RATE", "INSURED_COUNT"];
      let list = this.quotationData.quotationItems;
      for (let i in key) {
        let exit = list.find((item) => {
          return item.itemType == key[i];
        });
        if (exit &&exit.premiumRules && exit.premiumRules.length > 0) {
          this[key[i]] = true;
        } else {
          this[key[i]] = false;
        }
        if (exit && exit.itemType == "INSURED_COUNT") {
          this.MaxInsuredCount = exit.premiumRules[0].singlePremium;
        }
      }
    },
    handleSelectChange(value, formKey) {
      this.formInfo[formKey] = value;
    },
    changeTab(item, index) {
      sessionStorage.setItem("tab_", index);
      this.$router.push({
        name: "modelContent",
        query: { id: item.id, qid: this.quoteId },
      });
    },
    quotationLinkData(type, string, callback) {
      let data = {};
      if (type == "S") {
        data = {
          flag: type,
          quoteId: this.quoteId,
          content: string,
          uStr: this.$route.query.uStr,
        };
      } else if (type == "Q") {
        data = {
          flag: "Q",
          linkId: this.$route.query.linkId,
        };
      }
      return api.quotationLinkData(data).then((res) => {
        callback(res);
      });
    },
    handleDisplay() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          values.totalPremium = this.totalPremium;
          let formString = JSON.stringify(values);
          // sessionStorage.setItem("f_", formString);
          this.tempCalcul1(formString); //建工模板
        }
      });
    },
    tempCalcul1(formString) {
      this.quotationLinkData("S", formString, (res) => {
        if (this.isCheck) {
          let origin = window.location.origin;
          window.location.href =
            window.location.origin +
            `/pcmall/BJQ/display/${true}?id=${this.quoteId}&linkId=${
              res.data.msg
            }`;
        } else {
          this.$message.warning("请先阅读协议并勾选");
        }
      });
    },
    calculatePremium() {
      let data = {
        quoteId: this.quoteId,
        items: this.calculInfo.items,
      };
      sessionStorage.setItem("items", JSON.stringify(this.calculInfo.items));
      api.calculatePremium(data).then((res) => {
        this.totalPremium = res.data.msg.totalPremium;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page_ {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 100px;
  .text_ {
    padding: 15px 15px 0 15px;
    margin-bottom: 0;
  }
  .header {
    img {
      width: 100%;
      height: auto;
    }
  }
  .main_con {
    padding: 20px;
    margin: 0 auto;
    .block_ {
      padding: 10px;
      &.border_ {
        border: 1px solid #ccc;
        border-radius: 5px;
      }
    }
    .title_ {
      display: flex;
      margin: 10px 0;
      justify-content: space-between;
      span {
        // flex: 1;
        font-weight: bold;
        font-size: 15px;
      }
    }
  }
  .tab_ {
    display: flex;
    width: 92%;
    margin: 0 auto;
    color: #007aff;
    span {
      flex: 1;
      padding: 10px;
      text-align: center;
      position: relative;
      &.on::after {
        position: absolute;
        content: "";
        display: block;
        width: 20px;
        height: 1px;
        background-color: #007aff;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }

  .read {
    margin-top: 20px;
    display: flex;
    padding-left: 20px;
    .check {
      color: #ff5600;
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    box-shadow: 2px 0 17px 2px rgba(154, 183, 198, 0.35);
    span {
      flex: 1;
      background-color: #fff;
      text-align: center;
      color: #333;
      padding: 20px 10px;
      // &:nth-child(2n) {
      background-color: #007aff;
      color: #fff;
      // }
    }
  }
}
.s_flex_ {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  margin: 10px 0;
}
.tips_ {
  font-size: 12px;
  margin: 5px 0;
}
.tips_1 {
  margin-bottom: 30px;
}
.form_item_1 {
  margin-bottom: 0;
}
</style>
